import Loadable from "react-loadable";

export const InvestmentSidebarLink = Loadable({
  loader: () => import("../../../modules/manage-pitch").then((module) => module.InvestmentSidebarLink) as Promise<any>,
  loading: () => null,
});
